import React, { Component } from "react";
import pubsub from "pubsub-js";
// import { Link } from 'react-router-dom';
// import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ListGroup, ListGroupItem } from 'reactstrap';
import ToggleState from "../Common/ToggleState";
import TriggerResize from "../Common/TriggerResize";
import ToggleFullscreen from "../Common/ToggleFullscreen";
import HeaderRun from "./Header.run";
import smallIMG from "./../../../resources/MV.ico";
import largeIMG from "./../../../resources/MagicVision_White2.png";
import { Redirect } from "react-router";
import { Checkbox } from "@material-ui/core/";
import { Link, withRouter } from "react-router-dom";
import Authentication from "../../../../src/services/Authentication.js";
import ClientesList from "../../../../src/services/storageClient.js";
import Inputsearch from "./Input.js";
// import CloseButtons from "./components/closeBotton";
import { InputGroup, Input } from "reactstrap";
import "./style.scss";
import { Dropdown, List } from "semantic-ui-react";
import { Button } from "reactstrap";
import {Services} from "../Services";


const auth = new Authentication();
const clientSave = new ClientesList();
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      openselect: false,
      dataDrop: [],
      dataDrop1: [],
      checkAll: true,
      cont: 0,
      contadorSearch: 0
    };
  }
  componentDidMount() {
    console.log(
      "JSON.parse(auth.getAuthentication('customerSelect')",
      JSON.parse(auth.getAuthentication("customerSelect"))
    );

    let data = JSON.parse(auth.getAuthentication("customerSelect"));

    this.setState(
      {
        dataDrop: [...data] ? [...data] : [],
        dataDrop1: [...data] ? [...data] : [],
      },
      () => this.getCheck()
    );
    HeaderRun();
  }
  /*=============================================
    =            Handle Togle User Block         =
    =============================================*/
  toggleUserblock(e) {
    e.preventDefault();
    pubsub.publish("toggleUserblock");
  }
  /*=============================================
  =            Handle LogOut Function           =
  =============================================*/
  handleLogOut = () => {
    const createOffsetValue = (date) => {
      var sign = date.getTimezoneOffset() > 0 ? '-' : '+';
      var offset = Math.abs(date.getTimezoneOffset());
      var hours = Math.floor(offset / 60);
      var minutes = ((offset % 60) / 60) * 10;
      return sign + hours + '.' + minutes;
    };

    let endSession = {
      SessionId: auth.getAuthentication('token'),
      EndConnection: new Date(),
      timezone: createOffsetValue(new Date()),
      Logout: '1',
    };

    console.log("endSession",endSession);

    navigator.sendBeacon(
      // 'http://localhost:3019/user/logout',
      // 'https://www.magicanalytics.app/rr/api/auditoria/v1/user/logout',
      // 'https://rrapiauditoria.azurewebsites.net/user/logout',
      `${Services.AUDIT.path}user/logout`,
      JSON.stringify(endSession)
    );
    
    // Auth.signout(() => {
    //   this.setState({redirect: true});
    // });
  };

  removeToken = () => {
    this.handleLogOut();
    this.props.history.push("/");
    auth.deleteAuthentication("token");
    clientSave.deleteAuthentication("client");
    auth.deleteAuthentication("dataUser");
    auth.deleteAuthentication("customerSelect");
  };

  // handleSearch = (name) => (event) =>
  //   this.setState({ [name]: event.target.value }, () => this.setSearch());

  handleSearch = (name) => (event) => {
    if (event.keyCode === 32) {
      event.target.value = event.target.value + " "
    }
    this.setState({ [name]: event.target.value }, () => this.setSearch());
  }

  setSearch = () => {
    let haveSearch = false;
    let contSearch = []
    if (this.state.search.length > 0) {
      haveSearch = true;
    }
    let all = [...this.state.dataDrop];
    let newAll = all.map((e) => {
      let newE = { ...e };
      let newData2 = newE.data.map((item) => {
        const nameData = item.value
          ? item.value.toUpperCase()
          : "".toUpperCase();
        // const nameNIT = item.NIT ? item.NIT.toUpperCase() : ''.toUpperCase();
        const idData = item.id
          ? item.id.toString().toUpperCase()
          : "".toUpperCase();
        const textData = this.state.search.toUpperCase();
        if (nameData.indexOf(textData) > -1 || idData.indexOf(textData) > -1) {
          contSearch.push(item)
          item.hidden = false;
        } else {
          item.hidden = haveSearch ? true : false;
        }
        return item;
      });
      newE.data = newData2;
      return newE;
    });
    let finalAll = newAll.filter((item) => {
      return item.data.length > 0;
    });
    this.setState({ dataDrop: finalAll });
  };

  handeInputData = (selected) => (event) => {
    this.setState({ searchValue: event.target.value });
  };

  checkGroup = (index, all, uncheck) => {
    let newData = this.state.dataDrop;
    if (all) {
      if (uncheck) {
        newData[index].check = false;
        newData[index].data.map((e) => {
          e.check = false;
          return e;
        });
      } else {
        newData[index].check = true;
        newData[index].data.map((e) => {
          e.check = true;
          return e;
        });
      }
    } else {
      newData[index].check = !newData[index].check;
      newData[index].data.map((e) => {
        e.check = newData[index].check;
        return e;
      });
    }
    let x = 0;
    newData.map((e) => {
      e.data.map(e => {
        if (e.check) {
          x = x + 1
        }
        return e;
      })
      return e;
    })
    this.setState({ dataDrop: newData, contadorSearch: x });
  };

  getCheck = () => {
    let clientes = [];
    let NIT = [];
    this.state.dataDrop.map((e) => {
      e.data.map((f) => {
        if (f.check) {
          clientes.push(f.id);
          NIT.push(f.NIT);
        }
        return f;
      });
      return e;
    });
    this.setState({
      openselect: false,
      cont: clientes.length,
      contadorSearch: clientes.length
    });
    this.props.changeProps();
    clientSave.setAuthentication(clientes, NIT);
  };

  change = () => {
    this.setState({ openselect: false });
  };

  checkClient = (index, ind) => {
    let newData = this.state.dataDrop;
    newData[index].data[ind].check = !newData[index].data[ind].check;
    if (!newData[index].data[ind].check) {
      newData[index].check = false;
    }
    let x = 0;
    newData.map((e, index) => {
      e.data.map(e => {
        if (e.check) {
          x = x + 1
        }
        return e;
      })
      return e;
    })
    this.setState({ dataDrop: newData, contadorSearch: x });
  };

  checkAll = () => {
    if (!this.state.checkAll) {
      let newData = this.state.dataDrop;
      newData.map((e, index) => {
        this.checkGroup(index, true, false);
        return e;
      });
      this.setState({ checkAll: true });
    } else {
      let newData = this.state.dataDrop;
      newData.map((e, index) => {
        this.setState({ checkAll: false });
        this.checkGroup(index, true, true);
        return e;
      });
    }
  };

  render() {
    let { redirect, searchValue, dataDrop, checkAll } = this.state;
    if (redirect) return <Redirect to="/login" />;
    // let acction
    if (searchValue === "" || searchValue === undefined) {
    } else {
      return (
        <Link to={`/search/${encodeURIComponent(searchValue)}`}>
          <button className="d-none" type="submit">
            Submit
          </button>
        </Link>
      );
    }

    return (
      <header className="topnavbar-wrapper">
        {/* START Top Navbar */}
        <nav className="navbar topnavbar">
          {/* START navbar header */}
          <div className="navbar-header">
            <a className="navbar-brand" href="#/">
              <div className="brand-logo">
                <img className="img-fluid" src={largeIMG} alt="App Logo" />
              </div>
              <div className="brand-logo-collapsed">
                <img className="img-fluid" src={smallIMG} alt="App Logo" />
              </div>
            </a>
          </div>
          {/* END navbar header */}
          {/* START Left navbar */}
          <ul className="navbar-nav mr-auto flex-row">
            <li className="nav-item">
              {/* Button used to collapse the left sidebar. Only visible on tablet and desktops */}
              <TriggerResize>
                <ToggleState state="aside-collapsed">
                  <a
                    href=" "
                    className="nav-link d-none d-md-block d-lg-block d-xl-block"
                  >
                    <em className="fas fa-bars"></em>
                  </a>
                </ToggleState>
              </TriggerResize>
              {/* Button to show/hide the sidebar on mobile. Visible on mobile only. */}
              <ToggleState state="aside-toggled" nopersist={true}>
                <a href=" " className="nav-link sidebar-toggle d-md-none">
                  <em className="fas fa-bars"></em>
                </a>
              </ToggleState>
            </li>
            {/* START User avatar toggle */}
            <li className="nav-item d-none d-md-block">
              <a
                href=" "
                title="User"
                className="nav-link"
                onClick={this.toggleUserblock}
              >
                <em className="icon-user"></em>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href=" " data-search-open="">
                <em className="icon-magnifier"></em>
              </a>
            </li>
            <h2
              className="nav-link"
              style={{ color: "#fff", fontWeight: "100" }}
              href=" "
              data-search-open=""
            >
              |
            </h2>
            <li className="nav-item d-none d-md-block" >
              <i
                className="nav-link"
                onClick={() => {
                  this.setState({
                    openselect: !this.state.openselect,
                  });
                }}
              >
                <em
                  className="icon-people"
                  style={{ cursor: "pointer", fontSize: "15px" }}
                  title=""
                >
                  <i
                    style={{
                      fontSize: "11px",
                      marginLeft: "4px",
                      fontStyle: "normal",
                    }}
                  >
                    ▼
                  </i>
                  {/* Clientes */}
                  <Dropdown text="" open={this.state.openselect}
                    icon=''
                  // onClick={() => {
                  //   this.setState({
                  //     openselect: !this.state.openselect,
                  //   });
                  // }}
                  >
                    <Dropdown.Menu>

                      <div
                        style={{
                          background: "#bab9bc24",
                          width: "876px",
                          height: "330px",
                        }}
                      >
                        {/* <Col xs={12} style={{
                        background: "#bab9bc24",
                        width: "876px",
                        height: "330px",
                      }}> */}
                        {/* <Row> */}
                        {/* <Col xs={7}> */}
                        {/* <CardBody> */}
                        <div>
                          <InputGroup
                            style={{ width: "556px" }}
                          >
                            <Input
                              style={{
                                marginLeft: "23px",
                                marginTop: "21px",
                                height: "29px",
                              }}
                              // addonType="append"
                              placeholder="Customer Name"
                              // onChange={this.handleSearch("search")}
                              onKeyUp={this.handleSearch('search')}
                            />
                            <br></br>
                            {/* <div className='d-flex align-items-center'> */}

                            <em
                              className="fa-2x icon-magnifier"
                              style={{
                                padding: 5,
                                fontSize: "23px",
                                marginLeft: "10px",
                                color: "#a5a0a0",
                                marginTop: "24px",
                              }}
                            //   onClick={""}
                            ></em>
                            <div style={{ width: '2em' }}></div>
                            <h5 style={{ color: '#0e0e0e', marginTop: '28px', fontWeight: 'bold' }}>Selected Clients: <b>{this.state.contadorSearch}</b></h5>
                            {/* <Label style={{ color: 'black' }}>Selected Clients: </Label>{this.state.contadorSearch} */}

                            {/* <Badge badgeContent={this.state.contadorSearch} max={999} color="error">
                                    <GroupIcon
                                      style={{ fontSize: 32 }}
                                      // fontSize="large"
                                      color='primary' />
                                  </Badge> */}
                            {/* </div> */}
                          </InputGroup>
                        </div>
                        <div
                          style={{
                            textAlign: "right",
                            marginRight: "23px",
                            marginTop: "-33px",
                          }}
                        >
                          {/* <Label style={{ color: 'black' }}>Selected Clients: </Label>{this.state.contadorSearch} */}
                          {/* <Badge2 size="default" overflowCount={999} count={this.state.contadorSearch} style={{ backgroundColor: '#5cce2d5e' }}> */}
                          {/* </Badge2> */}

                          <Button color="danger" onClick={this.change}>x</Button>{" "}
                          <Button color="primary" onClick={this.getCheck}>✓</Button>{" "}
                        </div>
                        {/* </Row> */}
                        <div className="ui divider"></div>
                        <div style={{ overflowY: "scroll", height: "230px" }}>
                          <List
                            style={{
                              color: "black",
                              fontSize: "13px",
                              fontWeight: "bold",
                            }}
                            as="ol"
                          >
                            <List.Item as="li" value="">
                              <Checkbox
                                checked={checkAll}
                                onChange={this.checkAll}
                                value={""}
                              />
                              Check All
                            </List.Item>
                          </List>
                          <Dropdown.Divider />
                          <div>
                            <List
                              style={{
                                color: "black",
                                fontSize: "13px",
                                fontWeight: "bold",
                              }}
                              as="ol"
                            >
                              {dataDrop.map((e, index) => {
                                if (e.hidden) {
                                  return <></>;
                                } else {
                                  // let divider = <Dropdown.Divider />;
                                  // if (index + 1 === dataDrop.length) {
                                  // 	divider = <></>;
                                  // }
                                  return (
                                    <div key={index}>
                                      <List.Item as="li" value="">
                                        <Checkbox
                                          checked={e.check}
                                          onChange={() =>
                                            this.checkGroup(index)
                                          }
                                          key={index}
                                          value={e.id}
                                        />
                                        {e.value}
                                        <List.Item as="ol">
                                          {e.data.map((f, key) => {
                                            if (f.hidden) {
                                              return <></>;
                                            } else {
                                              return (
                                                <List.Item
                                                  style={{
                                                    fontWeight: "initial",
                                                    fontSize: "12px",
                                                  }}
                                                  as="li"
                                                  value=""
                                                  key={key}
                                                >
                                                  <Checkbox
                                                    checked={f.check}
                                                    onChange={() =>
                                                      this.checkClient(
                                                        index,
                                                        key
                                                      )
                                                    }
                                                    value={f.key}
                                                  />{" "}
                                                  {f.NIT} -- {f.value}
                                                </List.Item>
                                              );
                                            }
                                          })}
                                        </List.Item>
                                      </List.Item>
                                      {index + 1 !== dataDrop.length ? (
                                        <Dropdown.Divider />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  );
                                }
                              })}
                            </List>
                          </div>
                        </div>
                        {/* </Col> */}
                      </div>

                    </Dropdown.Menu>
                  </Dropdown>
                </em>
              </i>
            </li>
            {/* <div className='d-flex align-items-center'>
            <div style={{ padding: 10 }}>
              <span style={{ color: 'antiquewhite' }}><b>Total selected clients:</b></span>
            </div>
            <div style={{ padding: 10 }}>
              <Badge badgeContent={cont} max={999} color="primary" />
            </div>
          </div> */}
          </ul>
          <div style={{ width: "120px" }}></div>
          <h3
            style={{ fontSize: "13px", color: "white", letterSpacing: "10px" }}
            title=""
          >
            INTERGLOBO MEXICO
          </h3>
          <ul className="navbar-nav flex-row">
            <li className="nav-item d-none d-md-block">
              <ToggleFullscreen className="nav-link" />
            </li>
          </ul>
          <Inputsearch />
          <p onClick={this.removeToken} className="nav-item d-none d-md-block">
            <Link
              to=" "
              title="Log Out"
              className="nav-link"
              style={{ color: "#ffffff" }}
              // onClick={this.handleLogOut}
            >
              <em className="icon-logout"></em>
            </Link>
          </p>
        </nav>
      </header >
    );
  }
}
export default withRouter(Header);
